<template>
  <div class="w-full flex flex-col mt-2">
    <div class="grid grid-cols-12 gap-4">
      <div class="col-span-12">
        <c-text
          :value="
            Object.keys(kpaTypes).length > 0 && kpaTypes.name
              ? kpaTypes.name
              : `--Autoloads from agreement--`
          "
          placeholder="--Enter--"
          variant="w-full"
          class="mt-2"
          label="KPA"
          :disabled="true"
        />
      </div>

      <div class="col-span-12">
        <c-text
          :value="
            Object.keys(kpasItem).length > 0 && kpasItem.name
              ? kpasItem.name
              : `--Autoloads from agreement--`
          "
          placeholder="--Enter--"
          variant="w-full"
          class="mt-2"
          label="KPI"
          :disabled="true"
        />
      </div>

      <div class="col-span-12">
        <label>Criteria</label>
        <c-textarea
          :value="
            Object.keys(kpasItem).length > 0 && kpasItem.kpis.length > 0
              ? criteriaValues
              : `--Autoloads from agreement--`
          "
          placeholder="--Enter--"
          label="Criteria"
          :disabled="true"
        />
      </div>

      <div class="col-span-12">
        <c-text
          :value="
            Object.keys(kpasItem).length > 0 && kpasItem.weight
              ? kpasItem.weight
              : `--Autoloads from agreement--`
          "
          placeholder="--Enter--"
          variant="w-full"
          class="mt-2"
          label="Weight"
          :disabled="true"
        />
      </div>

      <div class="col-span-12">
        <span v-if="edit">
          <c-select
            :options="options"
            :placeholder="isView ? `` : `--Enter--`"
            variant="w-full"
            class="mt-2"
            label="Current Status"
            v-model="status"
            :disabled="isView"
            @change="status = $event"
          />
        </span>
        <c-text
          v-else
          :value="
            Object.keys(kpasItem).length > 0 && kpasItem.status
              ? kpasItem.status
              : ``
          "
          variant="w-full"
          class="mt-2"
          label="Current Status"
          :disabled="true"
        />
      </div>

      <div class="col-span-12">
        <span v-if="edit">
          <c-select
            :options="[
              { id: 'yes', name: 'Yes' },
              { id: 'no', name: 'No' },
            ]"
            :placeholder="isView ? `` : `--Enter--`"
            variant="w-full"
            class="mt-2"
            label="Need Support?"
            v-model="support"
            :disabled="isView"
            @change="support = $event"
          />
        </span>

        <c-text
          v-else
          :value="
            Object.keys(kpasItem).length > 0 && kpasItem.requireSupport
              ? kpasItem.requireSupport
              : ``
          "
          variant="w-full"
          class="mt-2"
          label="Need Support?"
          :disabled="true"
        />
      </div>

      <div class="col-span-12">
        <label>Comments</label>
        <span v-if="edit">
          <c-textarea
            :value="comment"
            label="Comments"
            :disabled="isView"
            @input="comment = $event"
          />
        </span>
        <c-textarea
          v-else
          :value="
            Object.keys(kpasItem).length > 0 && kpasItem.comment
              ? kpasItem.comment
              : ``
          "
          label="Comments"
          :disabled="true"
        />
      </div>
    </div>

    <div
      v-if="!isView && files.length < 5"
      @click="isUpload = true"
      class="text-base text-dynamicBackBtn font-normal cursor-pointer flex justify-start items-center gap-1 mt-3 border-t border-solid border-color pt-3"
    >
      <Icon icon-name="upload-icon-red" size="s" />
      <p>Upload</p>
    </div>

    <div v-if="files.length > 0" class="w-full h-auto flex flex-col gap-4">
      <div class="w-full" />
      <p
        class="w-full text-left pb-3 uppercase font-semibold text-romanSilver text-xs border-b border-solid border-color"
      >
        Uploaded Files
      </p>
      <div class="w-full h-auto flex flex-col gap-4">
        <div
          v-for="(file, index) in files"
          :key="index"
          class="w-full h-9 flex justify-between items-center gap-6"
        >
          <div class="w-auto flex justify-start items-center gap-1">
            <div class="w-9 h-full">
              <icon
                icon-name="pdf"
                size="s"
                class="icon"
                v-if="file.mimeType === 'pdf'"
              />
              <icon
                icon-name="doc"
                size="s"
                class="icon"
                v-else-if="file.mimeType === 'doc'"
              />
              <icon
                icon-name="xlsx"
                size="s"
                class="icon"
                v-else-if="file.mimeType === 'xlsx'"
              />
              <icon
                icon-name="csv"
                size="s"
                class="icon"
                v-else-if="file.mimeType === 'csv'"
              />
              <icon
                icon-name="ppt"
                size="s"
                class="icon"
                v-else-if="file.mimeType === 'ppt'"
              />
              <icon
                icon-name="png"
                size="s"
                class="icon"
                v-else-if="file.mimeType === 'png'"
              />
              <icon
                icon-name="jpg"
                size="s"
                class="icon"
                v-else-if="file.mimeType === 'jpg'"
              />
              <icon
                icon-name="jpg"
                size="s"
                class="icon"
                v-else-if="file.mimeType === 'jpeg'"
              />
            </div>

            <div class="flex flex-col justify-center items-start">
              <p class="text-blackJet text-base font-semibold py-0 my-0">
                {{ file.fileName }} {{ file.mimeType }}
              </p>
              <p class="text-xs py-0 my-0">
                <span class="text-blueCrayola">
                  {{ `document` }}
                </span>
                <span class="text-romanSilver">
                  • {{ file.fileSize.toFixed(2) }}
                </span>
              </p>
            </div>
          </div>
          <div v-if="edit" class="flex justify-center items-center gap-1">
            <div @click="downloadFile(file)" class="cursor-pointer h-full w-9">
              <Icon icon-name="black-download-icon" size="s" class="icon" />
            </div>
            <div
              @click="deleteUploadedFile(index)"
              class="cursor-pointer h-full w-9"
            >
              <icon icon-name="trash-icon" size="s" class="icon" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <UploadFile
      v-if="isUpload"
      @close="isUpload = false"
      @set-files="setFiles"
    />
    <DownloadFile
      v-if="openDownloadFile"
      @close="openDownloadFile = false"
      :item="selectedItem"
    />
  </div>
</template>

<script>
import CText from "@scelloo/cloudenly-ui/src/components/text";
import CSelect from "@scelloo/cloudenly-ui/src/components/select";
import CTextarea from "@scelloo/cloudenly-ui/src/components/text-area";
import UploadFile from "./UploadFile";
import DownloadFile from "./documents/DownloadFile";

export default {
  name: "StatusReport",
  components: {
    CText,
    CSelect,
    CTextarea,
    UploadFile,
    DownloadFile,
  },
  props: {
    edit: {
      type: Boolean,
      default: false,
    },
    isView: {
      type: Boolean,
      default: false,
    },
    kpasItem: {
      type: Object,
      default: () => ({}),
    },
    kpaTypes: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      selectedItem: {},
      openDownloadFile: false,
      isUpload: false,
      isUploaded: false,
      files:
        this.kpasItem?.report?.filesPath?.length > 0
          ? [...this.kpasItem.report.filesPath]
          : [],
      options: [
        { id: "completed", name: "Completed" },
        { id: "work_in_progress", name: "Work-in-Progress" },
        { id: "on_hold", name: "On-Hold" },
        { id: "cancelled", name: "Cancelled" },
      ],
      comment: "",
      support: "",
      status: "",
      criteriaValues: "",
    };
  },
  methods: {
    setFiles(files) {
      if (this.files.length > 0) {
        const allFiles = [...this.files, ...files];
        this.files = allFiles;
      } else {
        this.files = [...files];
      }
    },
    deleteUploadedFile(index) {
      if (this.files.length > 1) {
        this.files.splice(index, 1);
      } else {
        this.files.splice(index, 1);
        this.isUploaded = false;
      }
    },
    downloadFile(file) {
      this.openDownloadFile = true;
      this.selectedItem = file;
    },
  },
  watch: {
    files(newValue) {
      this.$emit("update-files", newValue);
    },
    comment(newValue) {
      this.$emit("update-comment", newValue);
    },
    support(newValue) {
      this.$emit("update-support", newValue);
    },
    status(newValue) {
      this.$emit("update-status", newValue);
    },
  },
  mounted() {
    if (
      Object.keys(this.kpasItem).length > 0 &&
      this.kpasItem.kpis.length > 0
    ) {
      const criteriaValues = this.kpasItem.kpis
        .map((item) => item.criteria)
        .filter(Boolean)
        .join(", ");
      this.criteriaValues = criteriaValues;
      this.$emit("kpis-criteriaValues", criteriaValues);
    }
    if (
      Object.keys(this.kpasItem).length > 0 &&
      this.kpasItem.report &&
      this.kpasItem.report !== "null"
    ) {
      this.comment = this.kpasItem.report.comment
        ? this.kpasItem.report.comment
        : "";
      this.support =
        this.kpasItem.report?.requireSupport === false ? "no" : "yes";
      this.status = this.kpasItem.report.status
        ? this.kpasItem.report.status
        : "";
    }
  },
};
</script>
<style scoped>
.border-color {
  border-color: #00000029;
}
</style>
